import React, { PureComponent } from 'react';
import './index.scss';
import CommonModal from '@/components/CommonModal';
import { BASEURL, isLogged, downLoadPage } from '@/utils/util';
import _ from 'lodash';
import {videoPrizeRecord} from '@/services/api';
export default class PrizeRecord extends PureComponent {
  state = {
    modalVisible: false,
    instructionModalVisible: false,
    currentData: {
      instructionTitle: '',
      instructionDesc: ''
    },
    prizeData: [
      // {
      //   prizeInfo: [],
      //   prizeId: '',
      //   prizeType: '',
      //   prizeDesc: '',
      //   title: '',
      //   instructionTitle: '',
      //   instructionDesc: '',
      // }
    ]
  }
  fetchPrizeRecord = async () => {
    const token = await isLogged() 
    if(!token){
      window.crgt.router.openLogin().then((res) => {
        if (res && res.code === 0) {
          window.location.reload();
        }
      });
      return;
    }
    const res = await videoPrizeRecord();
    const { prizeData } = res.data;
    this.setState({ prizeData, modalVisible: true })
  }
  closeModal = () => {
    this.setState({ modalVisible: false })
  }

  goToCouponPage = () => {
    const { isCRGT, isWXMp } = window.crgt;
    if (isCRGT) {
      window.crgt.router.openUrl({
        url: `${BASEURL}/couponPage`,
      });
      return;
    }
    if (isWXMp) {
      window.wx.miniProgram.navigateTo({
        url: `/pages/h5/index?url=${encodeURIComponent(`${BASEURL}/couponPage/#/`)}`,
      });
      return;
    }
    downLoadPage();
  }

  showInstructionModal = (data) => {
    const { instructionModalVisible } = this.state;
    const { instructionTitle, instructionDesc } = data
    this.closeModal();
    if (instructionModalVisible) return;
    this.setState({ instructionModalVisible: true, currentData: { instructionTitle, instructionDesc } })
  }

  closeInstructionModal = () => {
    this.setState({
      instructionModalVisible: false,
      currentData: {
        instructionTitle: '',
        instructionDesc: '',
      }
    });
  }

  getModalContent = () => {
    const { drawModalFontColor, drawPrizeFontColor, prizeBgCouponPartnerUrl, prizeBgCouponUrl, prizeInstructionCouponPartnerUrl, prizeInstructionCouponUrl, drawModalTopImgUrl, } = this.props;
    const { prizeData } = this.state;

    let renderHtml = '';
    if (_.isEmpty(prizeData)) {
      return <div className="prize-record-modal-container" style={{ color: drawModalFontColor }}>
        {!_.isEmpty(drawModalTopImgUrl) && <div className="prize-record-modal-top"><img src={drawModalTopImgUrl} /></div>}
        <div className="prize-record-modal-title">我的中奖记录</div>
        <div className="prize-record-modal-noPrize">暂无奖品</div>
      </div>
    } else {
      renderHtml = (<div className="prize-record-modal-container" style={{ color: drawModalFontColor }}>
        {!_.isEmpty(drawModalTopImgUrl) && <div className="prize-record-modal-top"><img src={drawModalTopImgUrl} /></div>}
        <div className="prize-record-modal-title">我的中奖记录</div>
        {prizeData.map(data => {
          const { prizeType, prizeInfo, title } = data.prize;
          if (prizeType === 'COUPONPARTNER') {
            return (<>
              {prizeInfo && prizeInfo.map(item => (
                <div className="prize-record-modal-content" style={{ backgroundImage: prizeBgCouponPartnerUrl && `url(${prizeBgCouponPartnerUrl})` }}>
                  <div className="prize-record-modal-content-left" style={{ color: drawPrizeFontColor }}>
                    <div className="title">{title}</div>
                    {item.prizeCode && <div className="desc">兑换码：{item.prizeCode}</div>}
                    {item.prizePass && <div className="desc">密码：{item.prizePass}</div>}
                    {item.expireTime && <div className="desc">{item.expireTime}</div>}
                  </div>
                  <div className="prize-record-modal-content-right" onClick={() => this.showInstructionModal(data.prize)}>
                    <img src={prizeInstructionCouponPartnerUrl} />
                  </div>
                </div>
              ))}
            </>);
          } else {
            return (<>
              {prizeInfo && prizeInfo.map(item => (
                <div className="prize-record-modal-content coupon" style={{ backgroundImage: prizeBgCouponUrl && `url(${prizeBgCouponUrl})` }}>
                  <div className="prize-record-modal-content-left" style={{ color: drawPrizeFontColor }}>
                    <div className="title">{title}</div>
                    {item.expireTime && <div className="desc">有效期：{item.expireTime}</div>}
                    <div className="desc" >已放入我的卡券， 请前往查看</div>
                  </div>
                  <div className="prize-record-modal-content-right" onClick={this.goToCouponPage}><img src={prizeInstructionCouponUrl} /></div>
                </div>
              ))}
            </>
            );
          }
        })}
        </div>)
        }

    return renderHtml;
  }
  renderText = (text) => {
    if (!_.isEmpty(text)) {
      const desc = text.split('；');
      return desc.map((item, index) => {
        if (_.isEmpty(item)) {
          return (<></>)
        }
        return (<p key={index}>{item}</p>)
      })
    }
    return text;
  }
  getInstructionModalContent = () => {
    const { drawModalFontColor, drawModalTopImgUrl } = this.props;
    const { instructionTitle, instructionDesc } = this.state.currentData;
    let renderHtml = '';
    renderHtml = (
      <div className="prize-record-modal-container" style={{ color: drawModalFontColor }}>
        {!_.isEmpty(drawModalTopImgUrl) && <div className="prize-record-modal-top"><img src={drawModalTopImgUrl} /></div>}
        <div className="prize-record-modal-title">{instructionTitle}</div>
        {this.renderText(instructionDesc)}
      </div>
    );
    return renderHtml;
  }
  render() {
    const { modalVisible, instructionModalVisible } = this.state;
    const { modalBgColor, prizeRecordImgUrl } = this.props;
    return (
      <>
        <div className="prize-record-container" onClick={this.fetchPrizeRecord} style={{ backgroundImage: prizeRecordImgUrl && `url(${prizeRecordImgUrl})` }}></div>
        <CommonModal closeBtn visible={modalVisible} modalBgColor={modalBgColor} onClose={this.closeModal} >{this.getModalContent()}</CommonModal>
        <CommonModal closeBtn visible={instructionModalVisible} modalBgColor={modalBgColor} onClose={this.closeInstructionModal} >{this.getInstructionModalContent()}</CommonModal>
      </>
    )
  }
}